import { Code } from "types/entities/Code";

export enum TaxonomyItemCodeFormValueKeys {
  CODE = "code",
  TYPE = "type",
}

export type TaxonomyItemCodeFormValues = Pick<Code, TaxonomyItemCodeFormValueKeys.CODE | TaxonomyItemCodeFormValueKeys.TYPE>;
